export default __webpack_public_path__ + "static/tip5-e50564df7f7630337d15f234cb3f1b6a.png";